import React from 'react';
import { useSelector } from 'react-redux';

import { ListHorizontal } from 'ui/components';
import { SkeletonText } from 'ui/components/skeleton';
import { formatDate, currencyFormat } from 'utilities/common';

import PODViewer from 'ui/components/imageViewer';

export const DetailPayable = ({ data }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Payable.Show']
  );

  const dummy = Array.from({ length: 10 }, (v, i) => i);

  return (
    <section id="billing">
      {StateLoading ? (
        <div style={{ width: 250 }}>
          <SkeletonText count={1} />
        </div>
      ) : (
        <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
          Informasi Penagihan
        </div>
      )}

      <div className="row mb-4">
        {StateLoading || !data ? (
          dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <SkeletonText count={1} />
            </div>
          ))
        ) : (
          <>
            <div className='row'>
              <div className='col-6'>
                <ListHorizontal
                  title="Tipe"
                  content={data?.type?.replace('_', ' ')}
                />
                <ListHorizontal
                  title="No. Referensi"
                  content={data?.ref_code || '-'}
                />
                {data?.vendor && (
                  <ListHorizontal
                    title="Vendor"
                    content={data?.vendor?.name}
                  />
                )}
                {data?.purchase_order && (
                  <ListHorizontal
                    title="PO"
                    content={data?.purchase_order?.code}
                  />
                )}

                <ListHorizontal
                  title="Projects"
                  content={
                    data?.projects?.map((e) => (
                      <div className='flex-column'>
                        <small className='info fs-9'>
                          - {e?.name}
                        </small>
                      </div>
                    ))
                  }
                />
              </div>
              <div className='col-6'>
                <ListHorizontal
                  title="Periode Project"
                  content={formatDate(data?.periode_project, 'YYYYMM')}
                />
                <ListHorizontal
                  title="Tanggal Pengajuan"
                  content={formatDate(data?.schedule_at, 'DD/MM/YYYY')}
                />
                {data?.type === 'vendor' && (
                  <>
                    {data?.term_of_payment > 0 && (
                      <ListHorizontal
                        title="Ketentuan Pembayaran"
                        content={`${data?.term_of_payment} Hari`}
                      />
                    )}

                    <ListHorizontal
                      title="Jatuh Tempo"
                      content={formatDate(data?.due_at, 'DD/MM/YYYY')}
                    />
                  </>
                )}
                <ListHorizontal title="Dibuat Oleh" content={data?.created_by} />
                <ListHorizontal
                  title="Dibuat Tanggal"
                  content={formatDate(data?.created_at)}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export const DetailDescription = ({ data }) => {
  const aliasName = (v) => {
    const arrays = {
      11: 'PPn 11',
      1.1: 'PPn 1.1',
      23: 'PPh Pasal 23',
      10: 'PPh Pasal 4(2)'
    }

    return arrays[v]
  }


  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Payable.Show']
  );

  const dummy = Array.from({ length: 10 }, (v, i) => i);

  return (
    <section id="description">
      <div className="row mb-4">
        {StateLoading || !data ? (
          dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <SkeletonText count={1} />
            </div>
          ))
        ) : (
          <div className='row'>
            <div className='col-6'>
              <ListHorizontal title="Catatan" className="border-0 " />
              <cite className="border-0 fs-8 tx-white-pre" >{data?.note || '-'}</cite>
              <hr />
              {data?.attachments && (
                <div className='row flex-wrap list-item m-0 align-items-center py-1 mb-1'>
                  <div className='p-0 fs-8'>
                    Attachments
                  </div>
                  <PODViewer
                    items={data?.attachments}
                    imgStyle={{ height: 60, width: 60, objectFit: 'cover' }}
                    imgClass="img-hover img-responsive rounded-3"
                    wrapperClass="row mt-2 w-100"
                    imgWrapperClass="col-6 p-2 border-1 border justify-content-center align-items-center d-flex flex-column"
                  />
                </div>
              )}
            </div>

            <div className='col-6'>
              <ListHorizontal
                title="Nominal"
                content={currencyFormat(data?.nominal, 'IDR')}
                colContent='col-7 text-uppercase text-end'
              />
              {data?.discount > 0 && (
                <ListHorizontal
                  title="Diskon"
                  content={currencyFormat(data?.discount, 'IDR')}
                  colContent='col-7 text-uppercase text-end'
                />
              )}
              {data?.ppn_nominal > 0 && (
                <ListHorizontal
                  title={aliasName(data?.ppn_percentage)}
                  content={currencyFormat(data?.ppn_nominal, 'IDR')}
                  colContent='col-7 text-uppercase text-end'
                />
              )}
              {data?.pph_nominal > 0 && (
                <ListHorizontal
                  title={aliasName(data?.pph_percentage)}
                  content={`(${currencyFormat(data?.pph_nominal, 'IDR')})`}
                  colContent='col-7 text-uppercase text-end'
                />
              )}

              <ListHorizontal
                title="Pemotongan"
                content={`(${currencyFormat(data?.down_payment, 'IDR')})`}
                colContent='col-7 text-uppercase text-end'
              />
              <ListHorizontal
                title="Total Tagihan"
                content={currencyFormat(data?.total_charges, 'IDR')}
                colContent='col-7 text-uppercase text-end'
              />
              <ListHorizontal
                title="Total Pembayaran"
                content={currencyFormat(data?.total_paid, 'IDR')}
                colContent='col-7 text-uppercase text-end'
              />
              <ListHorizontal
                title="Sisa Tagihan"
                content={currencyFormat(data?.total_charges - data?.total_paid, 'IDR')}
                colContent='col-7 text-uppercase text-end'
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
